<script lang="ts">
  import {
    CheckMark,
    CheckMarkCircle,
    CheckMarkSquare,
    QuestionMark,
    PlusMark,
    ArrowMark,
    PlayMark,
    Phone,
    Sent,
    Calendar,
    Basket,
    Message,
    Mail,
    Pin,
    ArrowTopRightIcon,
    CallIcon,
    MessageIcon,
    QuoteIcon,
  } from './icons/index';

  export let bulletIcon: string;

  let icon;

  $: if (bulletIcon === 'checkmark') {
    icon = CheckMark;
  } else if (bulletIcon === 'checkmark-circle') {
    icon = CheckMarkCircle;
  } else if (bulletIcon === 'checkmark-square') {
    icon = CheckMarkSquare;
  } else if (bulletIcon === 'question-mark') {
    icon = QuestionMark;
  } else if (bulletIcon === 'plus-mark') {
    icon = PlusMark;
  } else if (bulletIcon === 'arrow-mark') {
    icon = ArrowMark;
  } else if (bulletIcon === 'play-mark') {
    icon = PlayMark;
  } else if (bulletIcon === 'phone') {
    icon = Phone;
  } else if (bulletIcon === 'sent') {
    icon = Sent;
  } else if (bulletIcon === 'calendar') {
    icon = Calendar;
  } else if (bulletIcon === 'basket') {
    icon = Basket;
  } else if (bulletIcon === 'message') {
    icon = Message;
  } else if (bulletIcon === 'mail') {
    icon = Mail;
  } else if (bulletIcon === 'pin') {
    icon = Pin;
  } else if (bulletIcon === 'arrow-top-right') {
    icon = ArrowTopRightIcon;
  } else if (bulletIcon === 'arrow') {
    icon = ArrowTopRightIcon;
  } else if (bulletIcon === 'quote') {
    icon = QuoteIcon;
  } else if (bulletIcon === 'message-custom') {
    icon = MessageIcon;
  } else if (bulletIcon === 'call') {
    icon = CallIcon;
  } else {
    icon = CheckMark;
  }
</script>

<svelte:component this={icon} />
